// @ts-check
/** @jsx jsx */
import LandingPage from '@bottlebooks/gatsby-theme-event/src/components/LandingPage/LandingPage';
import { graphql } from 'gatsby';
import uniqBy from 'lodash/uniqBy';
import React from 'react';
import { jsx } from 'theme-ui';
import { usePremiumExhibitors } from '../../../useBottlebooksData';

export default function LandingTemplate({ data, pageContext, location }) {
  const { featuredExhibitors, event, locales } = useAfterQuery(data);
  const { minFeaturedExhibitors, limit, locale } = pageContext;
  const localeConfig = locales.find(
    (/** @type {{ locale: any; }} */ localeConfig) =>
      localeConfig.locale === locale
  );
  const exhibitors = React.useMemo(() => {
    if (featuredExhibitors.length > minFeaturedExhibitors) {
      return featuredExhibitors.slice(0, limit);
    }
    return uniqBy([...featuredExhibitors], ({ brandId }) => brandId).slice(
      0,
      limit
    );
  }, [featuredExhibitors, minFeaturedExhibitors, limit]);
  return (
    <LandingPage
      {...pageContext}
      event={event}
      localeConfig={localeConfig}
      exhibitors={exhibitors}
      producers={[]}
      location={location}
      withOverlay
    />
  );
}

export const pageQuery = graphql`
  query vv_LandingTemplate($eventId: ID!, $locale: Bottlebooks_ContentLocale) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        ...bb_LandingPage
      }
    }

    site {
      siteMetadata {
        locales {
          locale
          ...LandingPage_LocaleConfig
        }
      }
    }
  }
`;

function useAfterQuery(data) {
  const premiumExhibitors = usePremiumExhibitors();
  return {
    featuredExhibitors: premiumExhibitors,
    event: { ...data?.event, ...data?.bottlebooks?.event },
    locales: data.site.siteMetadata.locales,
  };
}
